export enum TalkStatus {
    Created = 'created',
    Done = 'done',
    Error = 'error',
    Started = 'started',
    Rejected = 'rejected',
}

export enum VideoType {
    CLIP = 'clip',
    TALK = 'talk',
    Scene = 'scene',
    TRAIN = 'train',
    EXPRESSIVE = 'expressive',
}

export enum ImageType {
    Upload = 'upload',
    Dreams = 'dreams',
    Backgrounds = 'backgrounds',
    UserPresenters = 'user-presenters',
    WithAgents = 'with-agents',
    Skeleton = 'skeleton',
}

export enum PresenterUsecase {
    Agent = 'agent',
    AgentV2 = 'agentV2',
    Video = 'video',
}

export interface IClip extends IVideo {
    presenter_id: string;
    driver_id: string;
    type: VideoType.CLIP;
    background?: { color: string };
}

export interface ITalk extends IVideo {
    type: VideoType.TALK;
}

export function isClip(video: IVideo): video is IClip {
    return (video as IClip).type === VideoType.CLIP;
}

export interface IVideo {
    id: string;
    order: number;
    source_url: string;
    thumbnail_url?: string;
    subtitles?: boolean;
    subtitles_url?: string;
    dns_source_url: string;
    driver_url: string;
    audio_url: string;
    duration: number;
    created_at: string;
    modified_at: string;
    status: TalkStatus;
    result_url: string;
    credits: string;
    persist?: boolean;
    user_data: {
        video_name: string;
        thumbnail_url: string;
    };
    created_by?: string;
    error?: { kind: string; description: string };
    expires: string;
    metadata?: any;
    name?: string;
    type: VideoType;
    config?: {
        logo?: {
            url: string;
        };
    };
    is_default?: boolean;
    background?: {
        color: string;
    };
}

export interface ITalksResponse {
    talks: IVideo[];
}
